import { Typography } from '@sravni/react-design-system';
import type { ComponentProps } from 'react';

import { useAppSelector } from 'shared/lib';

import { productTypeSelector } from 'entities/offersFilters';
import { isWLAvitoSelector } from 'entities/whiteLabels';

import { ANKETA_TITLES } from './AnketaTitle.texts';

type Props = {
  productType?: keyof typeof ANKETA_TITLES;
  className?: string;
  level?: ComponentProps<typeof Typography.Heading>['level'];
};

export const AnketaTitle: FC<Props> = (props) => {
  const { productType: productTypeProp, level = 3, className } = props;
  const isWlAvito = useAppSelector(isWLAvitoSelector);
  const productType = useAppSelector(productTypeSelector);

  if (productTypeProp) {
    return (
      <Typography.Heading
        level={level}
        className={className}
      >
        {ANKETA_TITLES[productTypeProp]}
      </Typography.Heading>
    );
  }

  if (!isWlAvito) {
    return null;
  }

  return (
    <Typography.Heading
      level={level}
      className={className}
    >
      {ANKETA_TITLES[productType]}
    </Typography.Heading>
  );
};
